// src/features/logs/useLogs.ts
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface LogEntry {
  id: number;
  user_id: string;
  user_display_name: string | null;
  action_type: string;
  target_type: string | null;
  target_id: string | null;
  before_value: unknown;
  after_value: unknown;
  created_at: string;
}

export interface LogsResponse {
  entries: LogEntry[];
  total: number;
  limit: number;
  offset: number;
}

export function useLogs(guildId: string | null, offset: number, limit = 50) {
  return useQuery({
    queryKey: ['logs', guildId, offset, limit],
    queryFn: () => apiFetch<LogsResponse>(`/api/logs/${guildId}?limit=${limit}&offset=${offset}`),
    enabled: !!guildId,
  });
}
